namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SpisovyPlanExport extends GContentBase {
        private form: JQuery<HTMLElement>;
        private spis_pl: string;
        private spis_pl_nazev: string;
        // 27.06.2022 - TFeik
        // Změna na SSL.
        private registerClass: string = 'Gordic.Ssl.Server.GExportSpisPlanAsync';//"Gordic.AdmIsl.Server.ExportSpisPlanAsync";

        private srv(): GContent {
            return this.createServiceContent("Gordic.Adm.WebControls.SpisovyPlanExport");
        }

        exportSpisPlan() {
            if (this.form.gform("isValid")) {
                var exportFileName = this.element.findFields("filename").gfield("getValue");
                var inputExport/*: Wfl.Interface.GInputExportSpisPlanDto*/ = {
                    filename: "{0}.xml".format(exportFileName),
                    spis_pl: this.spis_pl
                }
                Async.GTaskManager.start(this.registerClass, inputExport, { clearOnFinish: true, autoClean: true });
                this.close();
            }
        }

        onContentReady() {
            this.init();
        }

        private init() {
            this.createForm();
            this.initAsyncTask();
        }

        private createForm() {
            var form = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1" })
                .addRow("jres:32131121").addField("gstringbox", {
                    name: "spis-plan",
                    initialValue: "{0} - {1}".format(this.spis_pl, this.spis_pl_nazev),
                    disabled: true
                })
                .addRow("jres:33000023").addField("gstringbox", "w-8", { //RC 33000023 : Název souboru
                    name: "filename",
                    initialValue: "Spis-Pl-{0}".format(this.spis_pl),
                    validators: [new Gordic.Validators.Required({ stopping: true })]
                })
                .addField("gstringbox", "w-4", {
                    name: "extension",
                    initialValue: ".xml",
                    disabled: true
                })

            this.form = $("<div>").appendTo(this.element).gform("createFrom", form);
        }

        private initAsyncTask() {
            if (Async.GTaskManager.getAllTasks().find(item => item.className == this.registerClass) == undefined) {
                Async.GTaskManager.on("init", this.registerClass, function (o) {
                    var currentDate = new Date();
                    var exportNotId = "adm-export-{0}{1}{2}".format(currentDate.getHours(), currentDate.getMinutes(), currentDate.getSeconds());
                    var notif: IGNotificationOptions = {
                        id: exportNotId,
                        title: "jres:32131121",
                        icon: "fa-info-circle",
                        content: "jres:33000024" //RC 33000024 : Probíhá export spisového plánu
                    }
                    var not = new GObservableObject(notif);
                    this.customDto = { not: not, id: exportNotId };
                    $.content($("#main")).notification("add", notif, true);
                })
                Async.GTaskManager.on("always", this.registerClass, function (o) {
                    this.customDto = {};
                    $.content($("#main")).notification("remove", this.customDto.id);
                    this.clean();
                })
                Async.GTaskManager.on("fail", this.registerClass, function (o) {
                    $.content($("#main")).notification("remove", this.customDto.id);
                    this.customDto = {};
                    var notifError: IGNotificationOptions = {
                        icon: "fa-exclamation-circle",
                        shortTemplate: "<b>jres:33000025</b>", //RC 33000025 : Chyba při exportu spisového plánu.
                        content: {},
                        state: "error",
                    }
                    $.content($("#main")).notification("add", notifError, true);
                    this.clean();
                })
                Async.GTaskManager.on("done", this.registerClass, function (o) {
                    $.content($("#main")).notification("remove", this.customDto.id);
                    var currentDate = new Date();
                    var id = "spis-pl-success-{0}{1}{2}".format(currentDate.getHours(), currentDate.getMinutes(), currentDate.getSeconds());
                    var cnt = $.content($("#main"));
                    var notifOk: IGNotificationOptions = {
                        id: id,
                        icon: "fa-check-circle",
                        shortTemplate: "<b>jres:33000026</b><br /><i class='fa fa-external-link' aria-hidden='true'></i>&nbsp;<span>jres:33000027</span>", //RC 33000027 : Klikněte pro stažení spisového plánu
                        content: {},
                        state: "success",
                        defaultAction: new GAction({
                            name: "actDownloadFile",
                            run: (ev, ctx) => {
                                var form = new Gordic.Forms.Form({ customClass: "spis-pl-download" })
                                    .addRow("jres:33000028").addField("gstaticfield", { //RC 33000028 : Výsledek
                                        name: "result",
                                        initialValue: "<i class='fa fa-check-circle g-state-text g-state-success' aria-hidden='true'></i>&nbsp;<b>jres:33000029</b>" //RC 33000029 : Spisový plán byl úšpěšně vyexportován
                                    })
                                    .addRow("jres:33000030").addField("gfilefield", { //RC 33000030 : Soubor ke stažení
                                        name: "downloadfile-spis-pl",
                                        initialValue: o.result,
                                        canUpload: false,
                                        itemDeletable: false,
                                })
                                cnt.dialogs.simpleForm("jres:32131121", form, null, {
                                    dialogClass: "export-result-spis-pl",
                                    height: 200,
                                    width: 700,
                                    open: (ev, ctx) => {
                                        var notification = $(".gnotificationlist").gnotificationlist("findById", id);
                                        if (notification != null)
                                            cnt.notification("remove", notification);
                                    },
                                    commandBar: [
                                        {
                                            action: new GAction({
                                                name: "actDownloadSpisPl",
                                                customClass: "g-button--primary",
                                                caption: "jres:33000031", //RC 33000031 : Stáhnout
                                                run: (ev, ctx) => {
                                                    var downloadFile = $(".spis-pl-download").find(".gfilefield")
                                                    downloadFile.find("span.fa-cloud-download").click();
                                                }
                                            })
                                        },
                                        {
                                            actionContext: { file: o.result },
                                            action: new GAction({
                                                name: "actCloseSpisPl",
                                                caption: "jres:32131042",
                                                run: (ev, ctx) => {
                                                    var cnt = $.content($(ev.target));
                                                    cnt.createServiceContent("Gordic.Adm.WebControls.SpisovyPlanExport").call("ClearFile", { guid: ctx.file.guid }).done(() => {
                                                        cnt.close();
                                                    })
                                                }
                                            })
                                        }
                                    ]
                                })
                            }
                        })
                    }
                    cnt.notification("add", notifOk, true);
                })
            }
        }
    }
}